import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const HowItWorks = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const steps = [
    {
      number: '1',
      title: 'Tell us your task',
      description: 'What are you working on? A blog post, design project, coding task—whatever it is.',
    },
    {
      number: '2',
      title: 'Choose your vibe',
      description: 'Social, focused, or silent. Pick the session type that matches your mental state.',
    },
    {
      number: '3',
      title: 'Get matched',
      description: 'We will pair you with someone on a similar wavelength, ready to work alongside you.',
    },
    {
      number: '4',
      title: 'Start focusing',
      description: 'Join your session, introduce yourself, and get into the zone together.',
    },
  ];

  return (
    <section id="how-it-works" ref={sectionRef} className="py-24 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="text-center mb-16">
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              How it works
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Four simple steps to find your focus
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl p-8 shadow-lg transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white text-xl font-bold mb-6">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/register"
              className="inline-block px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white text-lg font-medium rounded-full transition-all shadow-lg hover:shadow-xl hover:scale-105"
            >
              Get started free
            </Link>
            <p className="mt-4 text-gray-600">No credit card required</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
